import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { LineReveal, Kicker } from "./Reveal";

export const PageHero = ({ kicker, title, accent, sub, image, crumb }) => (
    <section className="relative overflow-hidden bg-brand-ink pt-36 pb-20 sm:pt-44 sm:pb-24 grain" data-testid="page-hero">
        <div className="absolute inset-0">
            <img src={image} alt={`${title} — SS Engineering Works`} className="h-full w-full object-cover opacity-25" loading="eager" />
            <div className="absolute inset-0 bg-gradient-to-r from-brand-ink via-brand-ink/85 to-brand-ink/40" />
            <div className="technical-grid absolute inset-0" />
        </div>
        <div className="relative mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <p className="mb-5 flex items-center gap-1.5 font-mono text-[11px] tracking-[0.2em] text-slate-500 uppercase" data-testid="breadcrumb">
                <Link to="/" className="hover:text-brand-ember transition-colors">Home</Link>
                <ChevronRight size={12} />
                <span className="text-brand-ember">{crumb || title}</span>
            </p>
            <Kicker light>{kicker}</Kicker>
            <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[1.02] tracking-tight text-white">
                <LineReveal immediate>{title}</LineReveal>
                {accent && (
                    <LineReveal immediate delay={0.12} className="text-brand-ember">
                        {accent}
                    </LineReveal>
                )}
            </h1>
            {sub && <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400">{sub}</p>}
        </div>
    </section>
);
